import React from "react";
import { motion } from "framer-motion";
import { useAgeGate } from "@/context/AgeGateContext";
import Sparkles from "./Sparkles";

export default function AgeGate() {
  const { verified, confirm, deny } = useAgeGate();
  if (verified) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center" data-testid="age-gate-overlay">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://images.pexels.com/photos/8793891/pexels-photo-8793891.jpeg')",
        }}
      />
      <div className="absolute inset-0 bg-noir-base/85 backdrop-blur-sm" />
      <Sparkles />

      <motion.div
        initial={{ opacity: 0, y: 20, scale: 0.96 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="relative glass-panel rounded-lg max-w-md w-[90%] p-10 sm:p-12 text-center"
      >
        <div className="absolute -top-6 left-1/2 -translate-x-1/2">
          <div className="w-12 h-12 rounded-full bg-noir-surface border border-pink-hot/60 flex items-center justify-center glow-pink">
            <span className="font-display italic text-pink-hot">18+</span>
          </div>
        </div>

        <div className="font-body text-[10px] tracking-[0.35em] uppercase text-pink-blush mb-4 mt-2">
          Adults Only
        </div>
        <h1 className="font-display text-4xl sm:text-5xl text-champagne tracking-tight mb-4 leading-tight">
          <span className="italic text-pink-hot text-glow">Step inside</span><br />
          the private world
        </h1>
        <p className="text-sm text-champagne/70 mb-8 leading-relaxed">
          This website contains content intended for adults aged 18 or older. By entering, you confirm you are of legal age and consent to viewing.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={confirm}
            className="px-8 py-3 bg-pink-hot text-white text-xs tracking-[0.28em] uppercase rounded-sm hover:bg-pink-glow glow-pink transition-all"
            data-testid="age-gate-confirm"
          >
            I am 18 or older
          </button>
          <button
            onClick={deny}
            className="px-8 py-3 bg-transparent border border-champagne/30 text-champagne/70 text-xs tracking-[0.28em] uppercase rounded-sm hover:border-champagne/60 transition-all"
            data-testid="age-gate-deny"
          >
            Exit
          </button>
        </div>

        <div className="divider-gold mt-10 mb-4" />
        <div className="text-[10px] tracking-[0.3em] uppercase text-rosegold/60">
          Luxe · Pink · Noir
        </div>
      </motion.div>
    </div>
  );
}
